<div class="flex flex-col h-full">
  <div class="flex justify-between items-center mb-4 mt-4">
    <div class="flex flex-1">
      <div class="flex w-3/5">
        <elcia-search [control]="filterForm.controls.searchTerm"/>
      </div>
    </div>
    <div class="flex flex-1 justify-center">
      <elcia-period-navigator
        (periodChange)="onPeriodChange($event)"
        [periodTypes]="[PeriodType.Month, PeriodType.Week, PeriodType.Day, PeriodType.Year]"/>
    </div>
    <div class="flex flex-1 flex-row-reverse gap-2">
      <elcia-button (onClick)="showForm()" [label]="'action.add-timesheet' | translate" [icon]="'plus'"/>
      <elcia-button (onClick)="toggleFilterDisplayed()" [icon]="'filter'" [label]="'app.filters' | translate"
                    [severity]="isFilterDisplayed() ? 'primary' : 'secondary'"/>
    </div>
  </div>

  @if (isFilterDisplayed()) {
    <elcia-filter-container>
      <elcia-user-dropdown [control]="filterForm.controls.createdByIds" [isMulti]="true" [label]="'author'"/>
      <elcia-party-dropdown [control]="filterForm.controls.concernIds" [isMulti]="true" [partyTypes]="partyTypes()"/>
      <elcia-timesheet-type-dropdown [control]="filterForm.controls.timesheetTypeIds" [isMulti]="true"/>
      <elcia-timesheet-status-dropdown [control]="filterForm.controls.statusIds" [isMulti]="true"/>
      <elcia-dropdown
        [control]="filterForm.controls.isBillable"
        [items]="billableOptions()"
        [label]="'timesheet.billable' | translate"
        [textField]="'name'"
        [valueField]="'id'"
      />
    </elcia-filter-container>
  }

  <div class="flex-1 overflow-hidden">
    @if (isLoading()) {
      <elcia-loader/>
    } @else {
      <elcia-timesheet-grid
        (onDelete)="onTimesheetDelete($event)"
        (onDuplicate)="onTimesheetDuplicate($event)"
        (onStateChange)="onTimesheetStateChange($event)"
        (timesheetSelected)="onTimesheetSelect($event)"
        [canValidate]="canValidateTimesheet()"
        [timesheets]="timesheets()"/>
    }
  </div>
</div>


@if (isFormDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogSave()"
    (onClose)="closeForm()"
    (onDelete)="deleteTimesheet()"
    [isActionLoading]="isFormSaving()"
    [mustDisplayDeleteButton]="isEditMode()"
    [size]="'medium'"
    [title]="'entity.timesheet' | translate">

    @if (isLoadingSelectedTimesheet()) {
      <elcia-loader/>
    } @else {
      <elcia-timesheet-form
        (onSubmit)="submit($event)"
        [documents]="selectedTimesheetDocuments()"
        [initialValue]="selectedTimesheetFormValue()"
      />
    }
  </elcia-dialog>
}
